define('SageDotCom/Components/LoadMore',[
        "jquery",
        "underscore",
        "text!SageDotCom/Components/Templates/SpotlightCard.html",
        "text!SageDotCom/Components/Templates/IntacctResourceCard.html",
        "text!SageDotCom/Components/Templates/DigitalNewsroomCard.html",
        "eventManager"
    ],
    function ($, _, spotlightTemplate, intacctTemplate, digitalNewsroomTemplate, eventManager) {

        var currentPage = 1;

        function LoadMore(scope, data, div, itemsToLoad, itemsToLoadOnMobile, mode) {

            Object.defineProperties(this,
                {
                    $scope: { enumerable: true, value: $(scope) }
                });

            var $resultsDiv = $(div);
            var isMobile = $resultsDiv.hasClass("is-mobile");
            if (isMobile && itemsToLoadOnMobile !== undefined && itemsToLoadOnMobile !== null && itemsToLoadOnMobile > 0) {
                itemsToLoad = itemsToLoadOnMobile;
            }
            var resultsTemplate;

            var templateToUse = "";
            var resourceCounterEl = "";

            switch (mode) {
                case "spotlight":
                    {
                        templateToUse = spotlightTemplate;
                        break;
                    }
                case "intacct":
                    {
                        templateToUse = intacctTemplate;
                        resourceCounterEl = $('[id^="intacctresourcescenter-"] .intacct-resources-listings .resources-count');
                        break;
                    }
                case "digital-newsroom":
                    {
                        templateToUse = digitalNewsroomTemplate;
                        resourceCounterEl = $('[id^="digitalnewsroomlisting-"] .digital-newsroom-listings .resources-count');
                        break;
                    }
            }

            if (templateToUse === "") {
                //no valid mode, exit
                return;
            }

            resultsTemplate = _.template(templateToUse); // generate an underscore template
                
            var dataItems = data.length; //total number of data items

            //Check if the number of items to load is the same as as the number of items in the data.
            //Hide the button since the view will show a default number of items already
            if (dataItems <= itemsToLoad) {
                $("#remaining-loadmore, #intacct-loadmore, #digital-newsroom-loadmore").hide();
                itemsToLoad = dataItems;
            }

            $("#remaining-loadmore, #intacct-loadmore, #digital-newsroom-loadmore").click(function (e) {
                e.preventDefault();
                e.stopPropagation();

                var skip = (currentPage * itemsToLoad);
                var dataLoad = (skip + itemsToLoad);
                if (dataLoad > dataItems) {
                    //Need to work out what the actual dataLoad (remaining) should be.
                    dataLoad = (skip + (dataItems - skip));
                }

                var stories = "";
                for (var i = skip; i < dataLoad; i++) {
                    var item = data[i];
                    stories += resultsTemplate(item);
                }
                
                $resultsDiv.append(stories);
                currentPage += 1;

                //check to see if we need to hide the button
                if (dataItems <= dataLoad) {
                    $(this).hide();
                }
                updateResourceCounter(dataLoad);

                eventManager.trigger("invoke-lazy-load");
            });

            $("#remaining-loadmore, #intacct-loadmore, #digital-newsroom-loadmore").on("keypress", function (event) {
                if (event.keyCode === 13) {
                    $(event.target).click();
                }
            });

            function updateResourceCounter(dataLoad) {
                try {
                    if (resourceCounterEl !== "" && resourceCounterEl.length > 0) {
                        var resourceCounterElDataTemplate = $(resourceCounterEl).attr("data-template");
                        $(resourceCounterEl).attr("results-show", dataLoad);
                        resourceCounterElDataTemplate = resourceCounterElDataTemplate.replace("#", dataLoad).replace("##", $(resourceCounterEl).attr("results-total"));
                        $(resourceCounterEl)[0].innerText = resourceCounterElDataTemplate;
                    }
                } catch (e) { }
            }

            updateResourceCounter(itemsToLoad);
        }

        return function init(args) {
            return args.IsExperienceEditorEditing ? null : new LoadMore(args.scope, args.data, args.div, args.itemsToLoad, args.itemsToLoadOnMobile, args.mode);
        };
    });

